import { ClientEndpointType, NtcipDmsClientEndpoint } from "@app/shared";
import { useModel } from "@app/shared/src/hooks";
import { Input, InputRow } from "@app/dashboard/src/components/shared/inputs";
import { ClientEndpointEditorProps } from "./ClientEndpointEditor";

type EditNtcipDmsClientEndpointProps = {
} & ClientEndpointEditorProps;

export const EditNtcipDmsClientEndpoint: React.FC<EditNtcipDmsClientEndpointProps> = (props) => {
    const [, helper] = useModel(NtcipDmsClientEndpoint, props.endpoint as NtcipDmsClientEndpoint);
    const onChange = (newEndpoint: Partial<NtcipDmsClientEndpoint>) => {
        props.onChange({ ...newEndpoint as NtcipDmsClientEndpoint, endpointType: ClientEndpointType.NTCIP_DMS });
    };
    return (
        <>
            <InputRow><Input label="Endpoint Name" {...helper.bindingsFor("endpointName", onChange)} /></InputRow>
        </>
    );
}
